import { useContext, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./styles.css";
import { AuthContext } from "../../contexts/Authentication/AuthContext";
import { parseCookies } from "nookies";
import React from "react";

const ErrorLoginModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [context, setContext] = useState<string>("");
  const { loginErrorMessage } = useContext(AuthContext);
  const cookies = parseCookies();

  const handleModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const contextt = cookies["controlTower.context"];
    if (contextt !== undefined) {
      setContext(cookies["controlTower.context"]);
      setShowModal(true);
    }
  }, []);

  useEffect(() => {
    if (loginErrorMessage !== "") {
      setContext(loginErrorMessage);
      setShowModal(true);
    }
  }, [loginErrorMessage]);

  return showModal ? (
    <Modal
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={showModal}
      onHide={handleModal}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Aviso</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {context.split("#").map((line, index) => (
          <React.Fragment key={index}>
            <h5>{line}</h5>
          </React.Fragment>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="primary" onClick={handleModal}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  ) : (
    <></>
  );
};

export default ErrorLoginModal;
